import { render, staticRenderFns } from "./VueFinalModal.vue?vue&type=template&id=02823e40&scoped=true"
import script from "./VueFinalModal.vue?vue&type=script&lang=js"
export * from "./VueFinalModal.vue?vue&type=script&lang=js"
import style0 from "./VueFinalModal.vue?vue&type=style&index=0&id=02823e40&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02823e40",
  null
  
)

export default component.exports